<template>
  <div></div>
</template>

<script>
export default {
  props: {
    organization: Object,
  },
  data() {
    return {
      cache: {}, // events cache (for conflicts)
      fetch_events_busy: false,
      fetch_events_error: null,
      fetch_events_stack: [],
    }
  },
  methods: {
    fetchStaffAvailabilityEvents(locationIds) {
      return new Promise((resolve, reject) => {
        if (!this.fetch_events_busy) {
          this.processFetchEvents(locationIds, resolve, reject)
        } else {
          this.fetch_events_stack.unshift({
            locationIds: locationIds,
            resolve: resolve,
            reject: reject
          })
        }
      })
    },
    processFetchEvents(locationIds, resolve, reject) {
      if (locationIds.length === 0) {
        reject('Missing location ids')
        return
      }

      let events = this.getFromCache(locationIds)
      if (events.length > 0) {
        let locationIdsFromEvents = events.map(event => event.location_id)
        let uniqueLocationIds = locationIdsFromEvents.filter((id, index, self) => self.indexOf(id) === index)
        locationIds = locationIds.filter(id => !uniqueLocationIds.includes(id))
        if (locationIds.length === 0) {
          resolve(_.clone(events))
          if (this.fetch_events_stack.length > 0) {
            let { locationIds, resolve, reject } = this.fetch_events_stack.pop()
            this.processFetchEvents(locationIds, resolve, reject)
          }
          return
        }
      } 

      this.fetch_events_busy = true
      this.fetch_events_error = null

      let url = `/organization/${this.organization.id}/location/all_staff_availabilities?locationIds=${locationIds.join(',')}`

      axios.get(url)
        .then(response => {
          this.fetch_events_busy = false
          this.saveToCache(locationIds, response.data)
          let allEvents = events.concat(response.data)
          resolve(_.clone(allEvents))
          if (this.fetch_events_stack.length > 0) {
            let { locationIds, resolve, reject } = this.fetch_events_stack.pop()
            this.processFetchEvents(locationIds, resolve, reject)
          }
        })
        .catch(error => {
          this.fetch_events_busy = false
          this.fetch_events_error = _.errorFromAjax(error)
          reject(this.fetch_events_error)
        })
    },
    saveToCache(locationIds, events) {
      locationIds.forEach(id => {
        if(id === null) return
        let key = id.toString()
        this.cache[key] = {
          fetched_at: moment(),
          events: events.filter(event => event.location_id === id)
        }
      })
    },
    getFromCache(locationIds) {
      return locationIds.map(id => {
        if(id === null) return
        let key = id.toString()
        return this.cache[key] ? this.cache[key].events : []
      }).flat()
    },
  },
  mounted() {
    this.$emit('fetch-availabilities', this.fetchStaffAvailabilityEvents)
  },
}
</script>
